import { Pipe, PipeTransform, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

import * as fromRoot from '@core/redux';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs';

import { environment } from '../../../environments/environment';

const API_URL = environment.apiUrl;

interface FileValue {
  id: string;
}

@Pipe({
  name: 'imagePreview',
  standalone: true,
})
export class ImagePreviewPipe implements PipeTransform {
  private readonly store = inject<Store<fromRoot.State>>(Store);

  private readonly projectId = toSignal(this.store.pipe(select(fromRoot.getProjectSelectedId), takeUntilDestroyed()));

  private readonly accessToken = toSignal(
    this.store.pipe(
      select(fromRoot.getToken),
      filter(token => !!token),
      takeUntilDestroyed()
    )
  );

  transform(value: FileValue, width?: number | boolean, height?: number | boolean, isAvatar = false): string {
    if (!value?.id) {
      return '';
    }

    if (isAvatar) {
      return `${API_URL}files/view-avatar/${width}/${height}/${value.id}.png`;
    }

    const projectId = this.projectId();
    const accessToken = this.accessToken();

    if (!projectId || !accessToken) {
      return '';
    }

    let url = `${API_URL}files/${value.id}?projectId=${projectId}&access-token=${accessToken}`;

    if (width) {
      url += `&width=${width}`;
    }
    if (height) {
      url += `&height=${height}`;
    }

    return url;
  }
}
